module.exports = __webpack_public_path__ + "static/media/string.9d1b915f.png";